// extracted by mini-css-extract-plugin
module.exports = {"crossSellingCarousel":"CrossSellingCarousel_crossSellingCarousel__1z57K"};